// src/firebase.js
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBrYNEfLwnitPT0TsR4KtN1Jzfa62MlVow",
  authDomain: "naodito-62d26.firebaseapp.com",
  projectId: "naodito-62d26",
  storageBucket: "naodito-62d26.appspot.com",
  messagingSenderId: "633001081171",
  appId: "1:633001081171:web:8cc65ae7aaca710355c9a6",
  measurementId: "G-8VGK9H2W3Y",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };
